export type ResourceQueryKey = readonly unknown[];

export interface ResourceQueryReference {
  scopeKey: ResourceQueryKey;
}

export interface ResourceDefinition<
  Name extends string,
> extends ResourceQueryReference {
  name: Name;
}

export function defineResource<Name extends string>(
  name: Name,
): ResourceDefinition<Name> {
  return { name, scopeKey: [name] as const };
}
